// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../../theme/SwiperOverrides.css";

import * as styles from "./SectionUnderdogPromotedDogs.module.scss";

import React from "react";
import { Button } from "../../../components/common";

import { useQuery } from "@apollo/client";
import qs from "qs";
import { dogSearchClient } from "../../../apollo/client";
import { SEARCH_DOG_QUERY } from "../../../apollo/queries";
import DogCardCarousel from "../../../components/DogCardCarousel/DogCardCarousel";
import { Colours } from "../../../utils/colours";
import { mapEsDogDocToDogCarouselCardProps } from "../../../utils/mappers";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionSpotlightDogsProps {
	title: string;
	htmlIntro?: string;
	currentDogId: string;
	maxItems: number;
	jumpLinksTitle?: string;
}

export const SectionUnderdogPromotedDogs: React.FC<
	SectionSpotlightDogsProps
> = ({ currentDogId, maxItems, title, htmlIntro, jumpLinksTitle }) => {
	const { data } = useQuery(SEARCH_DOG_QUERY, {
		client: dogSearchClient,
		fetchPolicy: "cache-first",
		variables: {
			page: 0,
			sort: "NEW",
			isUnderdog: true,
			centres: [],
		},
	});

	const items = ((data?.results?.results || []) as DogsTrust.DogData[])
		.map(mapEsDogDocToDogCarouselCardProps)
		.filter((dog) => dog.id.toString() !== currentDogId)
		.slice(0, maxItems)
		.sort((a) => (a.imgSrc ? -1 : 0));

	return (
		<WrappedSection
			sectionName="SectionUnderdogPromotedDogs"
			sectionColour={Colours.SUNSHINE_YELLOW}
		>
			<section className={styles.spotlightdogsinner}>
				<header className={styles.titlewrapper}>
					{jumpLinksTitle ? (
						<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
							{title}
						</h2>
					) : (
						<h2 className={styles.title}>{title}</h2>
					)}
				</header>
				{htmlIntro?.length && (
					<div
						className={styles.introtext}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
						dangerouslySetInnerHTML={{
							__html: htmlIntro,
						}}
					/>
				)}
				<DogCardCarousel dogs={items} />
				<footer className={styles.buttonwrapper}>
					<Button
						variant={"secondary"}
						ariaLabel="link to our dogs"
						fullWidth={true}
						tabIndex={-1} // Link handles tab behaviour
						url={`/rehoming/dogs?${qs.stringify({
							isUnderdog: true,
						})}`}
					>
						{"Meet our underdogs"}
					</Button>
				</footer>
			</section>
		</WrappedSection>
	);
};

export default SectionUnderdogPromotedDogs;
